import { dynamicLoader } from '~/utils';

export const SideNavigationMenu = dynamicLoader({
  name: 'SideNavigationMenu',
  importFunc: () => import('./side-navigation-menu'),
});